var $fa90a5f91e9c891f$exports = {};
$fa90a5f91e9c891f$exports = {
    "backButton": (args)=>`N\xe1vrat na ${args.prevMenuButton}`,
    "moreActions": `Dal\u{161}\xed akce`,
    "unavailable": `Nen\xed k dispozici, rozbalen\xedm zobraz\xedte podrobnosti`
};


export {$fa90a5f91e9c891f$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
